var _sodipodi, _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgGroup02Delete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 90",
    id: "svg31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _sodipodi || (_sodipodi = /*#__PURE__*/React.createElement("sodipodi", {
    id: "namedview31",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#585c71;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 123,
    height: 92,
    id: "rect1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 0.49,
    width: 120,
    height: 90,
    id: "rect2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.48,
    y: 44.99,
    width: 120,
    height: 1,
    id: "rect3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.48,
    y: 43.49,
    width: 2,
    height: 4,
    id: "rect4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.48,
    y: 43.49,
    width: 2,
    height: 4,
    id: "rect5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.48,
    y: 42.49,
    width: 2,
    height: 6,
    id: "rect6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.48,
    y: 40.49,
    width: 2,
    height: 10,
    id: "rect7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.48,
    y: 30.49,
    width: 2,
    height: 30,
    id: "rect8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.48,
    y: 41.49,
    width: 2,
    height: 8,
    id: "rect9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.48,
    y: 41.49,
    width: 2,
    height: 8,
    id: "rect10"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.48,
    y: 44.49,
    width: 2,
    height: 2,
    id: "rect11"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.48,
    y: 25.49,
    width: 2,
    height: 40,
    id: "rect12"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.48,
    y: 20.49,
    width: 2,
    height: 50,
    id: "rect13"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.48,
    y: 25.49,
    width: 2,
    height: 40,
    id: "rect14"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.48,
    y: 15.49,
    width: 2,
    height: 60,
    id: "rect15"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.48,
    y: 25.49,
    width: 2,
    height: 40,
    id: "rect16"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.48,
    y: 33.49,
    width: 2,
    height: 24,
    id: "rect17"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.48,
    y: 35.49,
    width: 2,
    height: 20,
    id: "rect18"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.48,
    y: 5.49,
    width: 2,
    height: 80,
    id: "rect19"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.48,
    y: 12.49,
    width: 2,
    height: 66,
    id: "rect20"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.48,
    y: 35.49,
    width: 2,
    height: 20,
    id: "rect21"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.48,
    y: 30.49,
    width: 2,
    height: 30,
    id: "rect22"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.48,
    y: 35.49,
    width: 2,
    height: 20,
    id: "rect23"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.48,
    y: 39.49,
    width: 2,
    height: 12,
    id: "rect24"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.48,
    y: 43.49,
    width: 2,
    height: 4,
    id: "rect25"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.48,
    y: 42.49,
    width: 2,
    height: 6,
    id: "rect26"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.48,
    y: 31.49,
    width: 2,
    height: 28,
    id: "rect27"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.48,
    y: 37.49,
    width: 2,
    height: 16,
    id: "rect28"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.48,
    y: 41.49,
    width: 2,
    height: 8,
    id: "rect29"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.48,
    y: 43.49,
    width: 2,
    height: 4,
    id: "rect30"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.48,
    y: 43.49,
    width: 2,
    height: 4,
    id: "rect31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 60.48,31.49 a 14,14 0 1 1 -14,14 14,14 0 0 1 14,-14 m 0,-1 a 15,15 0 1 0 15,15 15,15 0 0 0 -15,-15 z",
    id: "path31"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.61,53.49 67.61,46.49 57.61,39.49 ",
    id: "polygon31",
    transform: "translate(-1,-1)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 123,
    height: 92,
    id: "rect1-8",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.907425,
      strokeOpacity: 1
    },
    d: "M 49.844842,37.600237 71.4604,52.787946",
    id: "line"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGroup02Delete);
export default __webpack_public_path__ + "static/media/img_group_02_delete.f26724747044daa82c37985420620ea1.svg";
export { ForwardRef as ReactComponent };